import moment from 'moment/moment';
import NodeRSA from 'node-rsa';

const encryptRSA = (token, warehouse) => {
    const key = new NodeRSA('-----BEGIN PRIVATE KEY-----\n' + token + '\n'+ '-----END PRIVATE KEY-----');
    const signature = {
        "timestamp": moment().format("YYYY-MM-DD HH:mm:ss"),
        "client_id": "UMMN",
        "warehouse_id": warehouse
    };
    const encrypted = key.encryptPrivate(signature, 'base64');
    return encrypted;
}

export default encryptRSA;